import Swiper from 'swiper/bundle';
import ThemeMap from '../utils/map';

const Home = {
  init() {
    Home.newsSlider();
    Home.heroSlider();
    ThemeMap.init(document.getElementById('map-wrap'));
  },

  heroSlider() {
    const heroEl = $(".hero");
    if (heroEl.length) {
      new Swiper(heroEl.find(".hero-slider")[0], {
        slidesPerView: 1,
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        pagination: {
          el: heroEl.find(".swiper-pagination")[0],
          bulletElement: "button",
          clickable: true,
        },
        autoplay: {
          delay: 5000,
        },
      });
    }
  },

  newsSlider() {
    const newsSwiperEl = $(".home-news");
    if (!newsSwiperEl.length) {
      return;
    }

    if (newsSwiperEl.length) {
      const navPrev = newsSwiperEl.find(".swiper-button--prev");
      const navNext = newsSwiperEl.find(".swiper-button--next");

      new Swiper(newsSwiperEl.find(".swiper")[0], {
        slidesPerView: 1,

        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },
      });
    }
  },

  partnersSlider() {
    const partnersEl = $(".partners");
    if (partnersEl.length) {
      const navPrev = partnersEl.find(".swiper-button-prev");
      const navNext = partnersEl.find(".swiper-button-next");

      new Swiper(partnersEl.find(".partners-slider")[0], {
        spaceBetween: 0,
        loop: true,
        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          400: {
            slidesPerView: 2,
          },
          600: {
            slidesPerView: 3,
          },
          900: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 5,
          },
        },
      });
    }
  },

  testimontialsSlider() {
    const sliderDom = $(".testi-slider");
    if (sliderDom.length) {
      const navPrev = sliderDom
        .closest(".testimonials")
        .find(".swiper-button-prev");
      const navNext = sliderDom
        .closest(".testimonials")
        .find(".swiper-button-next");

      new Swiper(sliderDom[0], {
        loop: true,

        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },
        pagination: {
          el: sliderDom.find(".swiper-pagination"),
          bulletElement: "button",
          clickable: true,
        },
      });

      $(document).on("click", ".testi-slide .btn-more", (e) => {
        const current = $(e.target);
        const short = current
          .closest(".testi-slide")
          .find(".testi-slide__desc--short");

        const full = current
          .closest(".testi-slide")
          .find(".testi-slide__desc--full");

        $(short).toggleClass("hidden");
        $(full).toggleClass("hidden");

        if (!$(short).hasClass("hidden")) {
          current.text(current.attr("data-more"));
        } else {
          current.text(current.attr("data-less"));
        }
      });
    }
  },
};

export default Home;
